import type { FindReplaceRule } from '@carboncopyco/types';
import { IFindAndReplaceRuleType } from '@carboncopyco/types';
import type React from 'react';
import type { RulePreviewLayout } from './Layout';
import { ReplaceImagePreview } from './ReplaceImagePreview';
import { ReplaceImageWithVariablePreview } from './ReplaceImageWithVariablePreview';
import { ReplaceValuePreview } from './ReplaceValuePreview';

export interface FindAndReplaceRulePreviewProps {
  rule: FindReplaceRule;
  layout?: RulePreviewLayout;
}
const ruleTypeToComponent: Record<IFindAndReplaceRuleType, React.ElementType> =
  {
    [IFindAndReplaceRuleType.replaceText]: ReplaceValuePreview,
    [IFindAndReplaceRuleType.replaceImage]: ReplaceImagePreview,
    [IFindAndReplaceRuleType.replaceImageWithVariable]:
      ReplaceImageWithVariablePreview,
    [IFindAndReplaceRuleType.snippet]: null,
    [IFindAndReplaceRuleType.replaceLink]: ReplaceValuePreview,
  };

export const FindAndReplaceRulePreview = ({
  rule,
  layout,
}: FindAndReplaceRulePreviewProps) => {
  const Preview = ruleTypeToComponent[rule.type];
  return Preview ? (
    <Preview
      {...rule}
      layout={layout}
    />
  ) : null;
};
